// @flow

import { h } from "preact";
import { connect } from "preact-redux";
import { PureComponent } from "shared-components";
import styles from "./styles.scss";
import classNames from "classnames";

import Dropdown from "components/Dropdown";

import { PUTTING } from "reducers/cart";

const SF_ANYTIME_TIERS = [
  {
    minQty: 2,
    price: 49,
  },
];

const SF_KIDS_TIERS = [
  {
    minQty: 2,
    price: 52,
  },
  {
    minQty: 5,
    price: 51,
  },
  {
    minQty: 10,
    price: 49,
  },
];

const CMORE_4842_TIERS = [
  {
    minQty: 2,
    price: 1959,
  },
  {
    minQty: 5,
    price: 1899,
  },
  {
    minQty: 10,
    price: 1859,
  },
];

const CMORE_4836_TIERS = [
  {
    minQty: 2,
    price: 1759,
  },
  {
    minQty: 5,
    price: 1699,
  },
  {
    minQty: 10,
    price: 1669,
  },
];

const CMORE_4833_TIERS = [
  {
    minQty: 2,
    price: 859,
  },
  {
    minQty: 5,
    price: 849,
  },
  {
    minQty: 10,
    price: 829,
  },
];

const CMORE_4827_TIERS = [
  {
    minQty: 2,
    price: 1229,
  },
  {
    minQty: 5,
    price: 1199,
  },
  {
    minQty: 10,
    price: 1159,
  },
];

const CMORE_4821_TIERS = [
  {
    minQty: 2,
    price: 305,
  },
  {
    minQty: 5,
    price: 299,
  },
  {
    minQty: 10,
    price: 289,
  },
];

const CMORE_4818_TIERS = [
  {
    minQty: 2,
    price: 959,
  },
  {
    minQty: 5,
    price: 939,
  },
  {
    minQty: 10,
    price: 909,
  },
];

const CMORE_4815_TIERS = [
  {
    minQty: 2,
    price: 469,
  },
  {
    minQty: 5,
    price: 465,
  },
  {
    minQty: 10,
    price: 455,
  },
];

const getPrice = function (qty, basePrice, id) {
  const tiers = () => {
    switch (id) {
      case 2194:
        return SF_ANYTIME_TIERS;
      case 4842:
        return CMORE_4842_TIERS;
      case 4836:
        return CMORE_4836_TIERS;
      case 4833:
        return CMORE_4833_TIERS;
      case 4827:
        return CMORE_4827_TIERS;
      case 4821:
        return CMORE_4821_TIERS;
      case 4818:
        return CMORE_4818_TIERS;
      case 4815:
        return CMORE_4815_TIERS;
      default:
        return SF_KIDS_TIERS;
    }
  };

  return (
    tiers()
      .filter((x) => qty >= x.minQty)
      .sort((a, b) => (a.minQty > b.minQty ? -1 : 1))
      .map((x) => x.price)[0] || basePrice
  );
};

@connect((state) => ({
  cartItems: state.cart.items,
  loading: state.cart.state === PUTTING,
}))
export default class MovieQtyPicker extends PureComponent {
  putCart = ({ value }) => {
    const items = this.props.cartItems.map((x) => ({
      productId: x.product.id,
      qty: x.qty,
    }));

    const item = items.find((x) => x.productId === this.props.product.id);

    if (item) {
      item.qty = value;
    } else {
      items.push({
        productId: this.props.product.id,
        qty: value,
      });
    }

    this.props.putCart(items.filter((x) => x.qty > 0));
  };

  render(
    { basePrice, msrp, cartItems, product, loading },
    _: any,
    { t }: Context
  ) {
    const optionsArray = [0, 1, 2, 3, 5, 10];
    const item = cartItems.find((x) => x.product.id === product.id);
    const qty = item ? item.qty : 0;
    return (
      <div class={styles.block}>
        <h2 class={styles.title}>
          {product.attributes.qty_title
            ? t("PRODUCT.QTY_TITLE", { title: product.attributes.qty_title })
            : t("PRODUCT.QTY_TITLE_FALLBACK")}
        </h2>

        <Dropdown
          class={styles.dropdown}
          name="qty"
          onSelect={this.putCart}
          required={true}
          value={qty}
          valueKey="value"
          disabled={loading}
          options={optionsArray.map((qtyOption) => ({
            value: qtyOption,
            label: (
              <Option
                basePrice={basePrice}
                msrp={msrp}
                qty={qtyOption}
                id={product.id}
              />
            ),
          }))}
        />
      </div>
    );
  }
}

class Option extends PureComponent {
  render(
    { basePrice, msrp, qty, id },
    _state: any,
    { t, formatPrice }: Context
  ) {
    const price = getPrice(qty, basePrice, id);
    const discount = Math.floor((1 - price / msrp) * 100);

    return (
      <div class={styles.option}>
        <span>{t("PRODUCT.DROPDOWN_PCS", { value: qty })}</span>
        {qty > 0 && (
          <span>
            {formatPrice(price)}
            <span class={styles.discount}>Spara {discount}%</span>
          </span>
        )}
      </div>
    );
  }
}
